export default {
  GET_LIST: '/nzjxcApi/SysPower/GetList',
  GET_POWER_LIST: '/nzjxcApi/SysPower/GetPowerList',
  SAVE: '/nzjxcApi/SysPower/Save',
  DELETE: '/nzjxcApi/SysPower/Delete',
  SORT: '/nzjxcApi/SysPower/Sort'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/menu/index.js